import React from "react";

import { Card, Col, MapInteractiveWithBoundedOverlay, Row } from "components";

export const CropShape = ({ field, geometry, location, overlay, setBbox = () => {} }) => (
  <Row gutter={[{ xs: 8, sm: 8, md: 16 }, 32]} className="margin-top-100">
    <Col md={24}>
      {location && geometry && (
        <Card className="map-card">
          <MapInteractiveWithBoundedOverlay geometry={geometry} location={location} overlay={overlay} field={field} onChange={(v) => setBbox(v)} />
        </Card>
      )}
    </Col>
  </Row>
);
